/**
 * Rule that is applied if an error message is provided by the consumer
 * @param {ValidationRuleParameters} params
 */
export const hasErrorRule = params => {
  return {
    triggered: Boolean(params.hasError),
    validationState: {
      isValid: !params.hasError,
      message: params.errorMessage,
      type: 'error',
      messageKey: 'hasError'
    }
  };
};